// extracted by mini-css-extract-plugin
export default {"headerSec":"topLogo_headerSec__CK6nM","headerLogo":"topLogo_headerLogo__ls2ua"};